import React, { useEffect } from 'react';

const InfoModal = ({
    isOpen,
    onClose,
    category = "INFO",
    title,
    subtitle,
    tabs = [],
    activeTab,
    onTabChange,
    maxWidth = '520px',
    children
}) => {
    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div 
            onClick={onClose} 
            style={{ 
                position: 'fixed', 
                inset: 0, 
                backgroundColor: 'rgba(10,7,3,0.55)', 
                zIndex: 9999, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                backdropFilter: 'blur(3px)', 
                padding: '24px' 
            }}
        >
            <style>{`
                @keyframes modalSlideUp {
                    0% { opacity: 0; transform: translateY(24px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                .info-modal-container {
                    animation: modalSlideUp 0.22s ease-out;
                }
            `}</style>
            <div 
                onClick={e => e.stopPropagation()} 
                className="info-modal-container"
                style={{ 
                    backgroundColor: '#FAFAF8', 
                    borderRadius: '20px', 
                    width: '100%', 
                    maxWidth: maxWidth, 
                    padding: '32px', 
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    position: 'relative'
                }}
            >
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div style={{ fontWeight: '800', fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase', color: '#C5A075' }}>
                        {category}
                    </div>
                    <button 
                        onClick={onClose} 
                        style={{ 
                            background: 'none', 
                            border: 'none', 
                            color: '#9E9690', 
                            fontSize: '22px', 
                            lineHeight: 1, 
                            cursor: 'pointer', 
                            padding: 0 
                        }}
                    >
                        ×
                    </button>
                </div>

                {/* Tabs */}
                {tabs && tabs.length > 0 && (
                    <div className="d-flex gap-2 mb-4" style={{ borderBottom: '1px solid #E9E4DB' }}>
                        {tabs.map(tab => {
                            const tabId = tab.id || tab;
                            const tabLabel = tab.label || tab;
                            const isActive = activeTab === tabId;
                            return (
                                <button 
                                    key={tabId} 
                                    onClick={() => onTabChange && onTabChange(tabId)}
                                    style={{ 
                                        background: 'none', 
                                        border: 'none', 
                                        padding: '0 4px 12px', 
                                        fontWeight: '700', 
                                        fontSize: '13px', 
                                        letterSpacing: '1px', 
                                        textTransform: 'uppercase', 
                                        color: isActive ? '#8B6914' : '#9E9690', 
                                        borderBottom: isActive ? '2px solid #C5A075' : '2px solid transparent', 
                                        cursor: 'pointer', 
                                        transition: 'all 0.15s', 
                                        marginBottom: '-1px' 
                                    }}
                                >
                                    {tabLabel}
                                </button>
                            );
                        })}
                    </div>
                )}

                {/* Title and Subtitle */}
                {(title || subtitle) && (
                    <div className="mb-4">
                        {title && <div style={{ fontWeight: '700', fontSize: '15px', color: '#1A110B' }}>{title}</div>}
                        {subtitle && <div style={{ fontSize: '12px', color: '#9E9690', marginTop: '2px' }}>{subtitle}</div>}
                    </div>
                )}

                {/* Content */}
                <div style={{ color: '#4A3728', fontSize: '13.5px', lineHeight: '1.8' }}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default InfoModal;
